module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/examples-videos.json
// module id = 802
// module chunks = 229240229434805